export function isVisibleBillingRecord(record) {
  return !record.isHiddenChannelBilled;
}

export function visibleBillingRecords(records) {
  if (!records) {
    return [];
  }

  return records.filter(isVisibleBillingRecord);
}

export async function loadUntilVisibleBillingRecords(
  infinityModel,
  { infinity, visibleCount } = {}
) {
  if (!infinityModel || (visibleCount !== undefined && visibleCount <= 0)) {
    return infinityModel;
  }

  while (visibleBillingRecords(infinityModel).length === 0 && infinityModel.canLoadMore) {
    await infinity.loadNextPage(infinityModel);
  }

  return infinityModel;
}
